import { Component } from '@angular/core';

@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss'],
    standalone: false
})
export class BaseComponent {
  showSidebar = true;

  constructor() { }

  menuButtonClicked() {
    this.showSidebar = !this.showSidebar;
  }

}
